import '../../styles/Navbar.less';
import { Avatar, Button, Grid, Image, Popover, Space, Typography } from 'antd';
import { CaretDownFilled, MenuOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { cookieUtils } from 'helpers/cookiesUtils';
import logoutHandler from 'helpers/logoutHandler';
import Logo from '../../assets/img/Logo.png';
import useTranslations from '../../hooks/useTranslations';


const { Text } = Typography;

const { getCookies } = cookieUtils;
const dataCookies = getCookies();

const SpaceStyled = styled(Space)`
    gap: unset !important;
`;
function Navbar({ setCollapsed }) {
    const navigate = useNavigate();
    const { t } = useTranslations();
    const { md } = Grid.useBreakpoint();

    const { user } = dataCookies;

    const textEasyMassage = t('EasyMassage', 'Easy Massage');
    const textLogout = t('Logout', 'Logout');
    const textAccountProfile = t('AccountProfile', 'Account Profile');


    return (
        <div className="navbar">
            <SpaceStyled>
                {!md && <Button type="text" icon={<MenuOutlined />} onClick={() => setCollapsed((prev) => !prev)} />}
                <Image style={{ width: 60, height: 60 }} src={Logo} alt="easy-message" preview={false} />
                {md && <Text strong>{textEasyMassage}</Text>}
            </SpaceStyled>
            <Popover
                overlayClassName="profile-menu"
                content={
                    <div className="profile-menu-item">
                        <span style={{ cursor: 'pointer' }} className="item" onClick={() => navigate('/admin/account-profile')}>
                            {textAccountProfile}
                        </span>
                        <span style={{ cursor: 'pointer' }} className="item" onClick={() => logoutHandler()}>
                            {textLogout}
                        </span>
                    </div>
                }
                trigger="click"
                getPopupContainer={(node) => node.parentElement}
                placement="bottomRight"
            >
                <Space style={{ cursor: 'pointer', alignItems: 'center', display: 'flex' }}>
                    <Avatar src={user?.profile_picture} />
                    <Space direction="vertical" size={0} style={{ lineHeight: 1 }}>
                        <Text>{user?.full_name}</Text>
                        <Text type="secondary">{user?.role}</Text>
                    </Space>
                    <CaretDownFilled />
                </Space>
            </Popover>
        </div>
    );
}

export default Navbar;
